import {algoliaKey} from '../algolia-config';

export const hostTopsortEnv = {
  prod: 'api-search.farmatodo.com',
  dev: 'farmatodo-co-sandbox.topsort.workers.dev',
};

export const hostAlgolia = {
  prod: 'vcojeyd2po-dsn.algolia.net'
}

export const algoliaEnv = {
  hitsPerPage: '24',
  envs: {
    prod: {
      id: 'VCOJEYD2PO',
      key: algoliaKey.prod,
      index: 'products-colombia',
      indexSub: 'products',
      properties: 'properties',
      propierties : {
        timePromTickets: 'TIME_PROM_TICKETS_COL'
      },
      items_seo: 'items_seo',
      hostTopsort: hostTopsortEnv.prod,
      hostAlgolia: hostAlgolia.prod
    },
    dev: {
      id: 'testingYA3RG061BL',
      key: algoliaKey.dev,
      index: 'products',
      properties: 'properties',
      items_seo: 'items_seo',
    },
    sandbox: {
      id: 'WOLGP9ZFDO',
      key: algoliaKey.sandbox,
      index: 'products',
      properties: 'properties',
      items_seo: 'items_seo',
    },
  },
  index: ['products', 'properties']
};
